import api from '@/api/creditControlDashboard';

const getDefaultState = () => ({
  statusMetrics: [],
  statusMetricsLoading: false,
  statusMetricsError: false,
  statusMetricsErrorResponse: null,

  creditControlAccounts: [],
  creditControlAccountsConfig: {
    page_size: 50,
    paginationCount: 0,
    page: 1,
    payment_method: '',
    last_dd_failed_reason: '',
    most_recent_payment_date: [],
    most_recent_payment_date__gte: '',
    most_recent_payment_date__lte: '',
    status: [],
    exclusion_kind: [],
    status_reason: [],
  },

  creditControlAccountsFilters: {
    paymentMethods: [
      {text: 'All', value: ''},
      {text: 'Annual', value: 'AN'},
      {text: 'Cheque', value: 'CQ'},
      {text: 'Direct Debit', value: 'DD'},
      {text: 'Manual Payer', value: 'MP'},
      {text: 'No Method Chosen', value: 'NO'},
      {text: 'Paypal', value: 'PP'},
      {text: 'Standing Order', value: 'SO'}
    ],

    lastDDFailedReasons: [
      {text: 'All', value: ''},
      {text: 'Account Closed', value: 'ACCOUNT CLOSED'},
      {text: 'Account Transferred', value: 'ACCOUNT TRANSFERRED'},
      {text: 'Advance Notice Disputed', value: 'ADVANCE NOTICE DISPUTED'},
      {text: 'Amount Not Due', value: 'AMOUNT NOT DUE'},
      {text: 'Amount Differs', value: 'AMOUNT DIFFERS'},
      {text: 'No Account', value: 'NO ACCOUNT'},
      {text: 'No Instruction', value: 'NO INSTRUCTION'},
      {text: 'Instruction Cancelled', value: 'INSTRUCTION CANCELLED'},
      {text: 'Payer Deceased', value: 'PAYER DECEASED'},
      {text: 'Presentation Overdue', value: 'PRESENTATION OVERDUE'},
      {text: 'Refer To Payer', value: 'REFER TO PAYER'},
      {text: 'Service User Differs', value: 'SERVICE USER DIFFERS'},
    ],

    statusMetrics: [
      {category: 'status', text: 'Bad Debt', value: 'Bad Debt'},
      {category: 'status', text: 'Blocked Bad Debt', value: 'Blocked Bad Debt'},
      {category: 'status', text: 'Pending Cease Bad Debt', value: 'Pending Cease Bad Debt'},
      {category: 'status', text: 'Handed Over', value: 'Handed Over'},
      {category: 'status', text: 'Write Off', value: 'Write Off'},
      {category: 'status', text: 'Written Off', value: 'Written Off'},
      {category: 'status', text: 'Dead Bad Debt', value: 'Dead Bad Debt'},
      {category: 'exclusion_kind', text: 'No Comms', value: 'comms'},
      {category: 'exclusion_kind', text: 'Excluded', value: 'exclude'},
      {category: 'status', text: '01 UDD', value: '01 UDD'},
      {category: 'status', text: 'Dead 01 UDD', value: 'Dead 01 UDD'},
    ],

    statusReasons: [
      {text: 'Dissolved', value: 'Dissolved'},
      {text: 'Liquid', value: 'Liquid'},
      {text: 'Bankrupt', value: 'Bankrupt'},
      {text: 'Voluntary strike off', value: 'Voluntary strike off'},
      {text: 'CVA', value: 'CVA'},
      {text: 'In administration', value: 'In administration'},
    ],
  },

  fetchCreditControlAccountsLoading: false,
  fetchCreditControlAccountsError: false,
  fetchCreditControlAccountsErrorResponse: null,

  exportCreditControlAccountsLoading: false,
  exportCreditControlAccountsError: false,
  exportCreditControlAccountsErrorResponse: null,

  sendCreditControlAccountsLoading: false,
  sendCreditControlAccountsError: false,
  sendCreditControlAccountsErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  FETCH_STATUS_METRICS_BEGIN(state) {
    state.statusMetricsLoading = true;
    state.statusMetricsError = false;
    state.statusMetricsErrorResponse = null;
  },
  FETCH_STATUS_METRICS_SUCCESS(state, payload) {
    state.statusMetricsLoading = false;
    state.statusMetrics = payload;
  },
  FETCH_STATUS_METRICS_ERROR(state, err) {
    state.statusMetricsLoading = false;
    state.statusMetricsError = true;
    state.statusMetricsErrorResponse = err;
  },

  FETCH_CREDIT_CONTROL_ACCOUNTS_BEGIN(state) {
    state.fetchCreditControlAccountsLoading = true;
    state.fetchCreditControlAccountsError = false;
    state.fetchCreditControlAccountsErrorResponse = null;
  },
  FETCH_CREDIT_CONTROL_ACCOUNTS_SUCCESS(state, payload) {
    state.fetchCreditControlAccountsLoading = false;
    state.creditControlAccountsConfig.paginationCount = payload.count;
    state.creditControlAccounts = payload.results;
  },
  FETCH_CREDIT_CONTROL_ACCOUNTS_ERROR(state, err) {
    state.fetchCreditControlAccountsLoading = false;
    state.fetchCreditControlAccountsError = true;
    state.fetchCreditControlAccountsErrorResponse = err;
  },

  SEND_CREDIT_CONTROL_ACCOUNTS_BEGIN(state) {
    state.sendCreditControlAccountsLoading = true;
    state.sendCreditControlAccountsError = false;
    state.sendCreditControlAccountsErrorResponse = null;
  },
  SEND_CREDIT_CONTROL_ACCOUNTS_SUCCESS(state) {
    state.sendCreditControlAccountsLoading = false;
  },
  SEND_CREDIT_CONTROL_ACCOUNTS_ERROR(state, err) {
    state.sendCreditControlAccountsLoading = false;
    state.sendCreditControlAccountsError = true;
    state.sendCreditControlAccountsErrorResponse = err;
  },

  EXPORT_CREDIT_CONTROL_ACCOUNTS_BEGIN(state) {
    state.exportCreditControlAccountsLoading = true;
    state.exportCreditControlAccountsError = false;
    state.exportCreditControlAccountsErrorResponse = null;
  },
  EXPORT_CREDIT_CONTROL_ACCOUNTS_SUCCESS(state) {
    state.exportCreditControlAccountsLoading = false;
  },
  EXPORT_CREDIT_CONTROL_ACCOUNTS_ERROR(state, err) {
    state.exportCreditControlAccountsLoading = false;
    state.exportCreditControlAccountsError = true;
    state.exportCreditControlAccountsErrorResponse = err;
  },

  UPDATE_CREDIT_CONTROL_ACCOUNTS_LOCAL(state, { account_id, payload }) {
    const account = state.creditControlAccounts.find(account => account.customer_id === account_id);
    
    if(account) {
      for(let key in account) {
        if(payload[key]) {
          account[key] = payload[key];
        }
      }
    }
  },

  UPDATE_CREDIT_CONTROL_ACCOUNTS_PAGINATION(state, payload) {
    state.creditControlAccountsConfig.page_size = payload.itemsPerPage;
    state.creditControlAccountsConfig.page = payload.page;
  },
  UPDATE_CREDIT_CONTROL_ACCOUNTS_FILTERS(state, payload) {
    state.creditControlAccountsConfig.page = 1;
    state.creditControlAccountsConfig.payment_method = payload.payment_method;
    state.creditControlAccountsConfig.last_dd_failed_reason = payload.last_dd_failed_reason;
    state.creditControlAccountsConfig.status_reason = payload.status_reason;
    state.creditControlAccountsConfig.most_recent_payment_date = payload.most_recent_payment_date;
    state.creditControlAccountsConfig.most_recent_payment_date__gte = payload.most_recent_payment_date.length ? payload.most_recent_payment_date[0] : '';
    state.creditControlAccountsConfig.most_recent_payment_date__lte = payload.most_recent_payment_date.length ? payload.most_recent_payment_date[1] ? payload.most_recent_payment_date[1] : payload.most_recent_payment_date[0] : '';
  },
  UPDATE_CREDIT_CONTROL_ACCOUNTS_STATUSES(state, payload) {
    state.creditControlAccountsConfig.page = 1;
    if(payload.status) {
      const index = state.creditControlAccountsConfig.status.indexOf(payload.status);
      if (index > -1) {
        state.creditControlAccountsConfig.status.splice(index, 1);
      } else {
        state.creditControlAccountsConfig.status.push(payload.status);
      }
    }

    if(payload.exclusion_kind) {
      const index = state.creditControlAccountsConfig.exclusion_kind.indexOf(payload.exclusion_kind);
      if (index > -1) {
        state.creditControlAccountsConfig.exclusion_kind.splice(index, 1);
      } else {
        state.creditControlAccountsConfig.exclusion_kind.push(payload.exclusion_kind);
      }
    }
  },
  REMOVE_CREDIT_CONTROL_ACCOUNTS_FILTER(state, payload) {
    state.creditControlAccountsConfig.page = 1;
    switch(payload) {
      case 'most_recent_payment_date':
        state.creditControlAccountsConfig.most_recent_payment_date = [];
        state.creditControlAccountsConfig.most_recent_payment_date__gte = '';
        state.creditControlAccountsConfig.most_recent_payment_date__lte = '';
        break;
      default:
        state.creditControlAccountsConfig[payload] = [];
    }
  },

  RESET_CREDIT_CONTROL_DASHBOARD_STORE(state) {
    Object.assign(state, getDefaultState());
  } 
};

const actions = {
  async fetchStatusMetrics({ commit, dispatch }) {
    commit('FETCH_STATUS_METRICS_BEGIN');
    try {
      const response = await api.fetchStatusMetrics();
      commit('FETCH_STATUS_METRICS_SUCCESS', response.data);
    } catch(err) {
      commit('FETCH_STATUS_METRICS_ERROR', err);
      dispatch('alerts/setAlert', {type: 'error', message: 'Some thing went wrong!'}, {root: true});
    }
  },

  async fetchCreditControlAccounts({ state, commit, dispatch }) {
    commit('FETCH_CREDIT_CONTROL_ACCOUNTS_BEGIN');
    try {
      const response = await api.fetchCreditControlAccounts(state.creditControlAccountsConfig);
      commit('FETCH_CREDIT_CONTROL_ACCOUNTS_SUCCESS', response.data);
    } catch(err) {
      let errorMessage = '';

      if (err.response.status === 400) {
        const errorSource = Object.keys(err.response.data)[0];
        errorMessage = err.response.data[errorSource][0];
      } else {
        errorMessage = err.response.data.detail;
      }
      commit('FETCH_CREDIT_CONTROL_ACCOUNTS_ERROR', errorMessage);
      dispatch('alerts/setAlert', {type: 'error', message: errorMessage}, {root: true});
    }
  },

  async exportToCSV({ state, commit, dispatch }) {
    commit('EXPORT_CREDIT_CONTROL_ACCOUNTS_BEGIN');
    try {
      const response = await api.exportToCSV(state.creditControlAccountsConfig);
      dispatch("alerts/setAlert", {type:"success",message: response.data.message}, { root: true });
      commit('EXPORT_CREDIT_CONTROL_ACCOUNTS_SUCCESS');
    } catch(err) {
      commit('EXPORT_CREDIT_CONTROL_ACCOUNTS_ERROR', err);
      dispatch('alerts/setAlert', {type: 'error', message: err.response.data}, {root: true});
    }
  },

  async sendToDialer({ state, commit, dispatch }) {
    commit('SEND_CREDIT_CONTROL_ACCOUNTS_BEGIN');
    try {
      const response = await api.sendToDialer(state.creditControlAccountsConfig);
      dispatch("alerts/setAlert", {type:"success",message: response.data.message}, { root: true });
      commit('SEND_CREDIT_CONTROL_ACCOUNTS_SUCCESS', response.message);
    } catch(err) {
      commit('SEND_CREDIT_CONTROL_ACCOUNTS_ERROR', err);
      dispatch('alerts/setAlert', {type: 'error', message: err.response.data}, {root: true});
    }
  },

  updateCreditControlAccountsPagination({ commit, dispatch }, payload) {
    commit('UPDATE_CREDIT_CONTROL_ACCOUNTS_PAGINATION', payload);
    dispatch('fetchCreditControlAccounts');
  },

  updateCreditControlAccountsFilters({commit, dispatch}, payload) {
    commit('UPDATE_CREDIT_CONTROL_ACCOUNTS_FILTERS', payload);
    dispatch('fetchCreditControlAccounts');
  },

  updateCreditControlAccountsStatuses({commit, dispatch}, payload) {
    commit('UPDATE_CREDIT_CONTROL_ACCOUNTS_STATUSES', payload);
    dispatch('fetchCreditControlAccounts');
  },

  removeCreditControlAccountsFilter({commit, dispatch}, payload) {
    commit('REMOVE_CREDIT_CONTROL_ACCOUNTS_FILTER', payload);
    dispatch('fetchCreditControlAccounts');
  }
};

const checkProductStatus = (status) => {
  const invalidStatuses = ['Warm', 'Lost', 'Void', 'Inbound', 'Index', 'For Approval', 'Verification', 'DOA', 'Cancel'];
  if (status) {
    return !invalidStatuses.includes(status);
  }

  return false;
}

const getters = {
  getStatusMetrics: state =>  { 
    return Object.entries(state.statusMetrics).reduce((final, [status, data]) => {
      final[status] = {
        ...data,
        status
      };

      return final;
    }, {});
  },
  getStatusMetricsLoading: state => state.statusMetricsLoading,
  getStatusMetricsError: state => state.statusMetricsError,
  getStatusMetricsErrorResponse: state => state.statusMetricsErrorResponse,

  getCreditControlAccounts: state => { 
    return state.creditControlAccounts.map(account => {       
      const products = [];
      checkProductStatus(account.telco_status) && products.push('Telco');
      checkProductStatus(account.voip_status) && products.push('VoIP');
      checkProductStatus(account.web_status) && products.push('Web');
      account.products = products.join(', ');

      return account;
  })},
  getCreditControlAccountsConfig: state => state.creditControlAccountsConfig,
  getCreditControlAccountsFilters: state => state.creditControlAccountsFilters,
  getFetchCreditControlAccountsLoading: state => state.fetchCreditControlAccountsLoading,
  getFetchCreditControlAccountsError: state => state.fetchCreditControlAccountsError,
  getFetchCreditControlAccountsErrorResponse: state => state.fetchCreditControlAccountsErrorResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
